import styled, { css } from 'styled-components';

export const Image = styled.div`
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  height: ${props => (props.height ? `${props.height}px` : 'auto')};
  background-color: ${props => (props.background ? props.background : 'transparent')};
  background-image: url("${props => props.url}");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 15px;
  
  ${props =>
    props.round &&
    css`
      border-radius: 100%;
      width: 44px;
      height: 44px;
      margin-top: 3px;
      margin-bottom: 3px;
    `}
`;



// WEBPACK FOOTER //
// ./src/styles/Image.js